var view_cart = false;

$(function () {
  if ($('body').find('.cart_view').length) {
    view_cart = true;
  }
  var $filterForm = $('form.js-catalog-filter');
  if ($filterForm) {
    var $submitButton = $filterForm.find('.js-catalog-filter-submit'),
      $inputs = $filterForm.find('input'),
      timeout = null;
    $inputs.on('change', function (e) {
      e.preventDefault();
      $submitButton.css({'display': '', 'top': e.target.parentElement.offsetTop + 'px'});

      if (timeout) {
        clearTimeout(timeout)
      }
      timeout = setTimeout(function () {
        var name = $(e.target).closest('.filter-prod__item').data('name');
        $.post(window.location.pathname + '?' + $filterForm.serialize(), function (resp) {
          for (var respKey in resp.map) {
            if (respKey !== name) {
              $filterForm.find('[data-name=' + respKey + '] input').map(function (i, input) {
                if (!input.checked) {
                  input.disabled = resp.map[respKey].indexOf(input.value) === -1;
                }
              });
            }
          }
        });
      }, 800);
    });
    $filterForm.on('submit', function (e) {
      e.preventDefault();
      $submitButton.hide();
      window.location.href = window.location.pathname + '?' + $(e.target).serialize()
    });

    $filterForm.find('.js-reset-filter').on('click', function (e) {
      window.location = this.dataset.link;
    });

    $('.js-catalog-sort').on('change', function (e) {
      if (this.value) {
        window.location = this.value;
      }
    });
  }

  Wishlist.init();
  Cart.onInitCallback = function () {
    productCardActivate(document.body);
    cartUpdate();
  };
  Cart.init();
});


function cartUpdate() {
  $('.js-basket-count').text(Cart.items.size);
  $('.js-basket-expected-count').text(Cart.expected.items.length);
  var total_weight = 0,
    total_volume = 0,
    total_price = 0;
  Cart.items.forEach(function (value) {
    total_weight += value.weight * value.qty;
    total_volume += value.volume * value.qty;
    total_price += value.price * value.qty;
  });
  $('.js-cart-weight-all').html(total_weight.toFixed(2) + '<span> кг</span>');
  $('.js-cart-volume-all').html(total_volume.toFixed(3) + '<span> м<sup>3</sup></span>');
  $('.js-cart-total-price').html(Meta.beautyPrice(total_price) + '<span> ₽</span>')
}

function wishlistUpdate() {
  $('.js-wishlist-count').text(Wishlist.items.size);
}

function changeQty(productId, newQty, cb) {
  if (isNaN(newQty)) {
    newQty = 1;
  }
  if (newQty < 1) {
    newQty = 1;
  }
  if (newQty > Cart.maxItemQty) {
    newQty = Cart.maxItemQty;
  }
  // если в корзине то изменяем число добавленных в корзину
  var product = Cart.getItemById(productId);
  if (product) {
    Cart.putItem({
      id: product.id,
      qty: newQty,
      price: product.price
    }, true, function () {
      cartUpdate();
      if (cb) {
        cb(Cart.getItemById(productId));
      }
    });
  }

  return newQty;
}

function updateWeightAndVolume($card, qty) {
  var $weight = $card.find('.js-cart-weight'),
    $volume = $card.find('.js-cart-volume');

  $weight.html((parseFloat($weight.data('value')) * qty).toFixed(2) + ' <span>кг</span>');
  $volume.html((parseFloat($volume.data('value')) * qty).toFixed(3) + ' <span>м<sup>3</sup></span>');
}

function productCardActivate(html) {
  $('.js-close-popup', html).on('click', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  $('.js-cart-clear').on('click', function () {
    Cart.removeAll();
    setTimeout(function () {
      window.location = '/';
    }, 300)
  });

  $('.js-wishlist-clear').on('click', function () {
    Cart.removeAll();
    setTimeout(function () {
      window.location = '/';
    }, 300)
  });

  $('.js-product', html).each(function () {
    var $card = $(this),
      data = $card.data('json'),
      product = Cart.getItemById(data.id),
      $countInput = $card.find('.js-count-card'),
      countMax = parseInt($countInput.attr('max')),
      countMin = parseInt($countInput.attr('min')) || 1,
      $sum = $('.js-item-price-sum', this)
    ;
    if ($card.hasClass('js-activated')) {
      return;
    }

    $card
      .find('.js-plus-card')
      .on('click', function (e) {
        e.preventDefault();
        product = Cart.getItemById(data.id);
        var qty = parseInt($countInput.val()) + 1;
        if (qty >= countMin && countMax >= qty) {
          qty = changeQty(data.id, qty, function (product) {
            $sum.html(Meta.beautyPrice(product.price * product.qty) + ' <span>₽</span>')
          });
        } else {
          qty = changeQty(data.id, countMax, function (product) {
            $sum.html(Meta.beautyPrice(product.price * product.qty) + ' <span>₽</span>')
          });
        }
        $countInput.val(qty);
        updateWeightAndVolume($card, qty);
        $sum.html(Meta.beautyPrice(product.price * qty) + ' <span>₽</span>')
      });

    $card
      .find('.js-minus-card')
      .on('click', function (e) {
        e.preventDefault();
        product = Cart.getItemById(data.id);
        var qty = parseInt($countInput.val()) - 1;
        if (qty >= countMin && countMax >= qty) {
          qty = changeQty(data.id, qty, function (product) {
            $sum.html(Meta.beautyPrice(product.price * product.qty) + ' <span>₽</span>')
          });
        } else {
          if (qty < countMin && !view_cart) {
            Cart.removeItem({id: data.id}, function () {
              cartUpdate();
              if (typeof (sendDatalayer) !== 'undefined') {
                if (typeof (getItemForDatalayer) !== 'undefined') {
                  const itemDatalayer = getItemForDatalayer(data);
                  sendDatalayer('remove_from_cart', [itemDatalayer]);
                }
              }
            });
            $card.find('.products__action').removeClass('products__action_in_cart');
            console.log('minus cart, card=');
          } else {
            qty = changeQty(data.id, countMin, function (product) {
              $sum.html(Meta.beautyPrice(product.price * product.qty) + ' <span>₽</span>')
            });
            if (qty != countMin) {
              qty = changeQty(data.id, qty, function (product) {
                $sum.html(Meta.beautyPrice(product.price * product.qty) + ' <span>₽</span>')
              });
            }
          }
        }
        if (qty > 0) {
          $countInput.val(qty);
          updateWeightAndVolume($card, qty);
          $sum.html(Meta.beautyPrice(product.price * qty) + ' <span>₽</span>')
        }
      });

    $countInput.on('input', function () {
      var qty = parseInt($(this).val());
      qty = changeQty(data.id, qty);
      if (qty >= countMin && countMax >= qty) {
        qty = changeQty(data.id, qty, function (product) {
          $sum.html(Meta.beautyPrice(product.price * product.qty) + ' <span>₽</span>')
        });
      } else {
        qty = changeQty(data.id, countMax, function (product) {
          $sum.html(Meta.beautyPrice(product.price * product.qty) + ' <span>₽</span>')
        });
      }
      $countInput.val(qty);
      updateWeightAndVolume($card, qty);
      $sum.html(Meta.beautyPrice(data.price * qty) + ' <span>₽</span>')
    });

    $card
      .find('.js-cart-delete')
      .on('click', function (e) {
        e.preventDefault();
        Cart.removeItem({id: data.id}, function () {
          cartUpdate();
          $card.remove();
          $('.tooltip').tooltip('hide');
          if (typeof (sendDatalayer) !== 'undefined') {
            if (typeof (getItemForDatalayer) !== 'undefined') {
              const itemDatalayer = getItemForDatalayer(data);
              sendDatalayer('remove_from_cart', [itemDatalayer]);
            }
          }
          if (Cart.items.size === 0) {
            window.location = '/';
          }
        });
      });

    $card
      .find('.js-count-confirm_wrong')
      .on('click', function (e) {
        e.preventDefault();
        $card.find('.js-plus-card').trigger('click');
        $card.find('.cart_count_warning').toggle();
      });

    var BUY_BTN_ACTIVE_CLASS = 'products__action-btn--add-basket',
      BUY_INFO_ITEM_SELECTOR = '.products__action-popup',
      BUY_INFO_ACTIVE_CLASS = 'products__action-popup--show';

    var buyBtn = $card.find('.js-buy-card');
      //var buyInfo = new InfoTooltip($card.find(BUY_INFO_ITEM_SELECTOR), BUY_INFO_ACTIVE_CLASS, [{
      //   target: buyBtn,
      //   activeClass: BUY_BTN_ACTIVE_CLASS
      // }])


    if (product && !$card.hasClass('js-inCart')) {
      // buyBtn.addClass(BUY_BTN_ACTIVE_CLASS);
      $countInput.val(product.qty);
      $sum.html(Meta.beautyPrice(product.price * product.qty) + ' <span>₽</span>');
    }

    buyBtn.on('click', function () {
      var qty = parseInt($countInput.val() ? $countInput.val() : 1),
        $this = $(this);

      if ($this.hasClass(BUY_BTN_ACTIVE_CLASS)) {
        Cart.removeItem({id: data.id}, function () {
          cartUpdate();
          $this.removeClass(BUY_BTN_ACTIVE_CLASS);
          buyInfo.hide();
          if (typeof (sendDatalayer) !== 'undefined') {
            if (typeof (getItemForDatalayer) !== 'undefined') {
              const itemDatalayer = getItemForDatalayer(data);
              sendDatalayer('remove_from_cart', [itemDatalayer]);
            }
          }
        });
      } else {
        Cart.putItem({
          id: data.id,
          price: data.price,
          qty: qty
        }, false, function () {
          cartUpdate();
          $countInput.val(qty);
          $sum.html(Meta.beautyPrice(data.price * qty) + ' <span>₽</span>')
          $card.find('.products__action').addClass('products__action_in_cart');
          // $this.addClass(BUY_BTN_ACTIVE_CLASS);
          // buyInfo.show();
          if (typeof (sendDatalayer) !== 'undefined') {
            if (typeof (getItemForDatalayer) !== 'undefined') {
              const itemDatalayer = getItemForDatalayer(data);
              sendDatalayer('add_to_cart', [itemDatalayer]);
            }
          }
        });
      }
    });

    var WISHLIST_BTN_ACTIVE_CLASS = 'products__wishlist-btn-active';

    $card.find('.js-wishlist-btn').on('click', function () {
      var $this = $(this);
      if ($this.hasClass(WISHLIST_BTN_ACTIVE_CLASS)) {
        Wishlist.removeItem({id: data.id}, function () {
          wishlistUpdate();
          $this.removeClass(WISHLIST_BTN_ACTIVE_CLASS);
        });
      } else {
        Wishlist.putItem({id: data.id}, false, function () {
          wishlistUpdate();
          $this.addClass(WISHLIST_BTN_ACTIVE_CLASS);
          $('#toast_live').find('.toast-body').text(data.title);
          $('#toast_live').toast('show');
        });
      }
    });

    $card
      .find('.js-wishlist-delete')
      .on('click', function (e) {
        e.preventDefault();
        Wishlist.removeItem({id: data.id}, function () {
          wishlistUpdate();
          $card.remove();
          if (Wishlist.items.size === 0) {
            window.location = '/';
          }
        });
      });

    $card.addClass('js-activated');
  });

  var $fast_view = $('.js-fast-view', html);
  if ($fast_view.length) {
    var $popup = $('#fast-view');
    $fast_view.on('click', function (e) {
      e.preventDefault();

      $.post(e.target.dataset.url, function (resp) {
        if (resp.success) {
          $popup.find('.popup__content').html(resp.html);
          $popup.find('.popup__top-title').html(resp.title);
          productCardActivate($popup.find('.popup__content'));
          fotorama_init($popup.find('.js-fotorama-popup'));
          tabs_activate($popup.find('.tabs'));
          $.magnificPopup.open({
            items: {
              src: '#fast-view'
            },
            type: 'inline'
          });
        }
      })
    })
  }

  var $remain_view = $('.js-remain-view', html);
  if ($remain_view.length) {
    var $remain_popup = $('#remain-view');
    $remain_view.on('click', function (e) {
      e.preventDefault();

      $.post(e.target.dataset.url, function (resp) {
        if (resp.success) {
          $remain_popup.find('.body_modal').html(resp.html);
          $remain_popup.find('.title_modal').html(resp.title);
          $('.js-close-popup').on('click', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
          });
          $.magnificPopup.open({
            items: {
              src: '#remain-view'
            },
            type: 'inline'
          });
        }
      })
    })
  }
  return html;
}
